<template>
    <div>
        <CommonLogin :login="login" :action="BIND_WECHAT" />
    </div>
</template>

<script>
import { BIND_WECHAT } from "@/enum/MEMBER_IMG_CODE_TYPE.js";
import CommonLogin from "../../components/common-login/CommonLogin.vue";
import userLoginToJudge from "../../services/userLoginToJudge.js";
import qs from "qs";
let query = qs.parse(location.search.slice(1));
export default {
    props: {
        from: {
            type: String,
            default: "",
        },
        saveKey: {
            type: String,
            require: true,
        },
        next: Function,
    },
    data() {
        this.BIND_WECHAT = BIND_WECHAT;
        return {};
    },
    components: { CommonLogin },
    methods: {
        login(data) {
            return this.$http({
                loading: true,
                url: "/bdzb-permission/member/wechat/bind",
                data: { ...data, code: query.ma_code, source: "WX" },
                method: "POST",
            }).then((data) => {
                console.log(data, "memberData");
                if (data.respCode == "00") {
                    const respData = data.respData;
                    sessionStorage.setItem(
                        `INVERTADVISER_WX_MEMBER_${this.saveKey}`,
                        JSON.stringify(respData)
                    );
                    // memberId: 1478940
                    // sign: "DFD17524D2033A19EA8E5822CD31264D10D81DCCF87A55E2F94D9650A873D682"
                    // source: "WX"
                    // userId: "1478940"
                    userLoginToJudge().then(() => {
                        if (this.next) {
                            this.next().then(() =>
                                this.$router.replace("/user-report")
                            );
                        } else {
                            if (/login/.test(this.from)) {
                                this.$router.replace("/");
                            } else {
                                this.$router.replace(`/${this.from}`);
                            }
                        }
                    });
                } else {
                    this.$toast(data.respDesc);
                }
            });
        },
    },
};
</script>
